"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var aabDomainsExternal = {
    'msp.money.pl': 'www.money.pl',
    'tech.money.pl': 'www.money.pl',
    'moto.money.pl': 'www.money.pl',
    'praca.money.pl': 'www.money.pl',
    'prawo.money.pl': 'www.money.pl',
    'nauka.money.pl': 'www.money.pl',
    'wibor.money.pl': 'www.money.pl',
    'konto.money.pl': 'www.money.pl',
    'manager.money.pl': 'www.money.pl',
    'agrobiznes.money.pl': 'www.money.pl',
    'money.kube.dev.dcwp.pl': 'www.money.pl',
};
exports.default = aabDomainsExternal;
